import { render } from "./PolicyGlobalModal.vue?vue&type=template&id=23ee5f44"
import script from "./PolicyGlobalModal.vue?vue&type=script&lang=js"
export * from "./PolicyGlobalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__